export const CREATE = 'Entity/ActBookingAgencyBooker/CREATE'
export const CREATE_SUCCESS = 'Entity/ActBookingAgencyBooker/CREATE_SUCCESS'
export const CREATE_FAILURE = 'Entity/ActBookingAgencyBooker/CREATE_FAILURE'

export const DELETE = 'Entity/ActBookingAgencyBooker/DELETE'
export const DELETE_SUCCESS = 'Entity/ActBookingAgencyBooker/DELETE_SUCCESS'
export const DELETE_FAILURE = 'Entity/ActBookingAgencyBooker/DELETE_FAILURE'
